import http from '@/communication/AuthConnection'

export default () => {
  return http.get('/v1/users')
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/user/ListUsers.js